import { useTranslation } from 'react-i18next';
import { CheckCircle, Camera, Monitor } from 'lucide-react';

const LandingHowItWorks = () => {
  const { t } = useTranslation();
  const STEPS = [
    { icon: CheckCircle, title: t('landing.step1Title'), description: t('landing.step1Desc') },
    { icon: Camera, title: t('landing.step2Title'), description: t('landing.step2Desc') },
    { icon: Monitor, title: t('landing.step3Title'), description: t('landing.step3Desc') },
  ];

  return (
    <section id="how-it-works" className="py-20 sm:py-28 px-4 bg-muted/30">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-primary uppercase tracking-wider mb-2">{t('landing.simpleSetup')}</p>
          <h2 className="text-3xl sm:text-4xl font-bold">{t('landing.howItWorks')}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STEPS.map((step, i) => (
            <div key={i} className="relative text-center space-y-4">
              <div className="mx-auto w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
                <step.icon className="h-7 w-7 text-primary" />
              </div>
              <div className="absolute -top-2 -end-2 w-7 h-7 rounded-full bg-primary text-primary-foreground text-xs font-bold flex items-center justify-center">
                {i + 1}
              </div>
              <h3 className="text-lg font-semibold">{step.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingHowItWorks;
